import React, { useContext, useEffect, useRef, useState } from "react";
import { DailyPanditBookingAPI } from "../../ApiServices/DailyPanditAPI/DailyPanditApi";
import { Link, useNavigate, useParams } from "react-router-dom";
import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
// import Batuk from "../../assets/images/new/Batuk2.png";
import Batuk from "../../assets/images/new/fav-removebg-preview.png";
import {
  BlogCategoryList,
  CurrentBlogData,
  GetBlogCategoryList,
  GetWebAppBlogList,
} from "../../ApiServices/BlogApi/BlogAPI";
import { Helmet } from "react-helmet-async";
import "./blog.css";
import { LoaderContext } from "../../AuthContext/AuthContext";
import { t } from "i18next";
import NoResultFoundModel from "../../Components/NoDataFound/NoDataFoundModal";

const CommonBlogPage = () => {
  const user_id = localStorage.getItem("userID");
  const [searchKeyWord, setSearchKeyWord] = useState("");
  const [blogList, setblogList] = useState([]);
  const [dailyPanditPujaListData, setDailyPanditPujaListData] = useState([]);
  const [currentBlog, setCurrentBlog] = useState([]);
  const [searchBtnClick, setSearchClicked] = useState(false);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(18);
  const [hasMore, setHasMore] = useState(true);
  const isFetching = useRef(false);
  const [totalRecords, setTotalRecords] = useState(-1);

  const navigate = useNavigate();
  const { setLoader, loader, activeCategory, setActiveCategory, selectedLanguageID } =
    useContext(LoaderContext);
  const { slug } = useParams();

  const [categories, setCategories] = useState([]);


  const GetCurrentBlog = async (params) => {
    if (isFetching.current || !hasMore) return; // 🛑 stop further calls

    setLoader(true);
    isFetching.current = true;

    const selectedCat = activeCategory === "All" ? null : activeCategory;
    const response = await GetWebAppBlogList(params, selectedCat, Number(selectedLanguageID));

    if (response?.statusCode === 200) {
      const blogs = response?.responseData?.data || [];

      if (blogs.length === 0) {
        setHasMore(false); // ⛔ stop further infinite scroll
      } else {
        setTotalRecords(blogs.length);
        setblogList((prev) => [...prev, ...blogs]);

        if (start === 0) {
          setCurrentBlog(
            blogs.find((item) => item.blogSlug === slug) || blogs[0]
          );
        }
      }


    }

    setLoader(false);
    isFetching.current = false;
  };

  const GetSearchedBlog = async (params) => {


    setLoader(true);

    const selectedCat = activeCategory === "All" ? null : activeCategory
    const response = await GetWebAppBlogList(params, selectedCat, Number(selectedLanguageID));
    if (response?.statusCode === 200) {
      const blogs = response?.responseData?.data || [];
      const count = response?.totalCount
      setLoader(false);

      setblogList(blogs);
      setTotalRecords(blogs.length);
    }

    setLoader(false);
    isFetching.current = false;
  };

  const handleScroll = () => {
    // 🛑 Stop if already loading or no more data left
    if (loader || !hasMore) return;

    // 🧭 Trigger when user nears the bottom of the page
    if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 300) {
      const newStart = start + 1;
      const newEnd = end + 9;
      setStart(newStart);
      setEnd(newEnd);
    }
  };


  useEffect(() => {
    GetCategories();
    GetSearchedBlog({
      pageNo: start === 0 ? 0 : start,
      pageSize: 18,
      sortingDirection: null,
      sortingColumnName: null,
      searchKeyword: null,
      fromDate: null,
      toDate: null,

    });
  }, [selectedLanguageID])
  useEffect(() => {
    GetCurrentBlog({
      pageNo: start === 0 ? 0 : start,
      pageSize: 18,
      sortingDirection: null,
      sortingColumnName: null,
      searchKeyword: null,
      fromDate: null,
      toDate: null,

    });
  }, [start, end]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [loader, hasMore]);

  useEffect(() => {
    if (searchBtnClick) {
      GetSearchedBlog({

        pageNo: 0,
        pageSize: 100,
        sortingDirection: null,
        sortingColumnName: null,
        searchKeyword: searchKeyWord,
        fromDate: null,
        toDate: null,

      });
      setSearchClicked(false);
    }
  }, [searchBtnClick]);

  const GetCategories = async () => {

    setLoader(true);
    const response = await GetBlogCategoryList(Number(selectedLanguageID));

    if (response?.statusCode === 200) {
      const categories = response?.responseData?.data || [];
      setLoader(false);

      const formattedStateList = [
        { value: "All", label: "All" },
        ...categories.map((value) => ({
          value: value.blogCatID,
          label: value.blogCatName,
        })),
      ];
      setCategories(formattedStateList);
    } else {
      setLoader(false);
    }

  };

  // const GetCurrentBlog = async (params) => {
  //   //  ;
  //   setLoader(true);

  //   const response = await CurrentBlogData(params);

  //   if (response.ResponseCode === "0" && response.ResponseMessage === "list") {
  //     setLoader(false);
  //     const blogs = response?.DATA;
  //     setblogList(blogs);
  //     setCurrentBlog(blogs.find((item) => item.blogSlug === slug));
  //     //   if (blogs.length > 0) {
  //     //     if (location.state) {
  //     //       setCurrentBlog(location.state.blog);
  //     //     } else {
  //     //       setCurrentBlog(blogs[0]); // Set the first blog as the current blog
  //     //     }
  //     //   }
  //   } else {
  //     setLoader(false);
  //   }
  // };


  const stripHtml = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.innerText || tempDiv.textContent || "";
  };

  const viewDetail = (puja) => {

    navigate("/services/daily-booking/puja-details", {
      state: { puja: puja },
    });
  };

  const handleCategoryClick = (category) => {
    setActiveCategory(category.value);
    setSearchClicked(true);
    setSearchKeyWord("");
  };


  return (
    <>
      <section className="page-header" style={{ marginBottom: "2rem" }}>
        <div className="page-header__bg"></div>
        <div className="container">
          <h2 className="page-header__title bw-split-in-left">
            {t("Spiritual Gyan -  Belief Redefined")}
          </h2>
        </div>
      </section>
      <Helmet>
        {/* Meta Title & Description */}
        <title>Spiritual Gyan - Insights, Rituals & Divine Knowledge</title>
        <meta
          name="description"
          content="Explore spiritual wisdom, rituals, and divine insights on our blog. Enhance your spiritual journey with meaningful knowledge and guidance."
        />

        {/* Canonical URL */}
        <link rel="canonical" href="https://www.myomnamo.com/spiritual-gyan" />

        {/* Open Graph Meta Tags */}
        <meta
          property="og:title"
          content="Spiritual Gyan - Insights, Rituals & Divine Knowledge"
        />
        <meta
          property="og:description"
          content="Explore spiritual wisdom, rituals, and divine insights on our blog. Enhance your spiritual journey with meaningful knowledge and guidance."
        />
        <meta
          property="og:image"
          content="https://www.myomnamo.com/assets/images/new/logo.png"
        />
        <meta
          property="og:url"
          content="https://www.myomnamo.com/spiritual-gyan"
        />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Myomnamo" />
        <meta property="og:locale" content="en_IN" />

        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Spiritual Gyan - Insights, Rituals & Divine Knowledge"
        />
        <meta
          name="twitter:description"
          content="Explore spiritual wisdom, rituals, and divine insights on our blog. Enhance your spiritual journey with meaningful knowledge and guidance."
        />
        <meta
          name="twitter:image"
          content="https://www.myomnamo.com/assets/images/new/logo.png"
        />

        {/* Schema Markup - Breadcrumbs */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://www.myomnamo.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Spiritual Gyan",
                item: "https://www.myomnamo.com/spiritual-gyan",
              },
            ],
          })}
        </script>

        {/* WebPage Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "WebPage",
            name: "Spiritual Gyan - Insights, Rituals & Divine Knowledge",
            url: "https://www.myomnamo.com/spiritual-gyan",
            description:
              "Explore spiritual wisdom, rituals, and divine insights on our blog. Enhance your spiritual journey with meaningful knowledge and guidance.",
            publisher: {
              "@type": "Organization",
              name: "Myomnamo",
            },
          })}
        </script>
      </Helmet>
      <div
        className="container "
        style={{ display: "flex", flexDirection: "column" }}
      >
        {/* Search Bar */}
        <div className="row ">
          <div className="col-md-6 mx-auto">
            <div
              className="search-box"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flex: "1",
                maxWidth: "100%",
                marginRight: "10px",
                position: "relative", // Needed for absolute positioning
              }}
            >
              <input
                type="text"
                className="custom-search-input"
                placeholder="Search"
                value={searchKeyWord}
                onChange={(e) => setSearchKeyWord(e.target.value)}
                style={{
                  padding: "8px 35px 8px 10px", // Space for the icon on the right
                  width: "100%",
                }}
              />
              <span
                onClick={() => {
                  setActiveCategory("All");
                  setSearchClicked(true);
                }}
                style={{
                  position: "absolute",
                  right: "10px",
                  cursor: "pointer",
                  color: "#a52444",
                }}
              >
                <i className="fas fa-search"></i> {/* Font Awesome icon */}
              </span>
            </div>
          </div>
        </div>
        <div className="category-tabs-container">
          <ul className="nav justify-content-center border-bottom">
            {categories.map((cat, idx) => (
              <li className="nav-item " key={idx}>
                <button
                  className={`nav-link-blog category-tab-btn ${activeCategory === cat.value ? "active" : "InActive"
                    } `}
                  style={{ fontSize: "medium" }}
                  onClick={() => handleCategoryClick(cat)}
                >
                  {cat.label}
                </button>
              </li>
            ))}
          </ul>
          <br></br>
          {/* Optional: filtered content placeholder */}
          {/* <div className="mt-3">
            Showing results for: <strong>{activeCategory}</strong>
          </div> */}
        </div>
        {/* Puja Cards */}
        <section className="blog-one " style={{ paddingTop: "0px" }}>
          <div className="container">
            <div className="row gutter-y-2" style={{ justifyContent: "left" }}>
              {blogList?.length > 0 && (
                blogList.map((blog, index) => (
                  <div className="col-md-4 col-lg-4 d-flex " data-aos="fade-up"
                    key={index}>


                    <div
                      className="blog-card wow fadeInUp d-flex flex-column h-100"
                      data-wow-duration="1500ms"
                      data-wow-delay="100ms"
                      style={{ "--accent-color": "#FF5528" }}
                    >
                      <div className="blog-card__image" >
                        <img src={blog.blogImage} alt={blog.blogTitle} style={{ objectFit: 'contain ' }} />
                        <img src={blog.blogImage} alt={blog.blogTitle} style={{ objectFit: 'contain ' }} />.
                        <Link
                          to={`/spiritual-gyan/${blog.blogSlug}`}
                          className="blog-card__image__link"
                        >
                          <span className="sr-only">{blog.blogTitle}</span>
                        </Link>
                        <div className="blog-card__date">
                          <i className="icofont-ui-calendar"></i>
                          {blog.blogDate ? blog.blogDate : "Date not available"}
                        </div>
                      </div>

                      <div className="blog-card__content flex-grow-1 d-flex flex-column">
                        <ul
                          className="list-unstyled blog-card__meta"
                          style={{ fontSize: "12px" }}
                        >
                          <li>
                            <Link
                              style={{
                                marginRight: "15px",
                                color: "black",
                                fontSize: "12px",
                              }}
                            >
                              {blog.autherName || "-"}
                            </Link>
                          </li>
                          <li>
                            <Link
                              to={`/spiritual-gyan/${blog.blogSlug}`}
                              style={{ color: "black", fontSize: "12px" }}
                            >
                              <i class="fa-solid fa-clock"></i>{" "}
                              {blog?.readingTime || 3}
                              <span className="text-decoration-none" style={{ marginLeft: "3px" }}>
                                {t("Min")}
                              </span>
                            </Link>
                          </li>
                        </ul>

                        <h3
                          className="blog-card__title"
                          style={{ fontSize: "20px" }}
                        >
                          <Link to={`/spiritual-gyan/${blog.blogSlug}`}>
                            {blog.blogTitle}
                          </Link>
                        </h3>

                        <p
                          className="blog-card__text"
                          style={{ wordBreak: "break-word" }}
                        >
                          {stripHtml(blog.blog).length > 85
                            ? `${stripHtml(blog.blog).substring(0, 85)}...`
                            : stripHtml(blog.blog)}
                        </p>

                        <Link
                          to={`/spiritual-gyan/${blog.blogSlug}`}
                          className="blog-card__link mt-auto"
                        >
                          <span className="blog-card__link__front">
                            <span className="icofont-double-right"></span>
                          </span>
                          <span className="blog-card__link__back">
                            <span className="icofont-double-right"></span>
                            {t("Read More")}
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                ))
              )}

              {totalRecords <= 0 && (
                <NoResultFoundModel moduleName={"spirituaslGyan"} totalRecords={totalRecords} />
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default CommonBlogPage;
